<template>
  <BaseModal modalColor="border-warning bg-warning" iconModal="fa fa-warning" subtitulo="Editar perfil"
             col-md="col-md-3" offset="3">
    <template v-slot:modalContent>
      <form @submit.prevent="submitEditPerfilForm">
        <div class="row">
          <div class="col-md-12" style="text-align: center">
            <div class="form-group">
              <img v-if="dado.foto" class="img-circle" width="100px" height="100px" id="profile_img"
                   alt="foto de perfil"
                   :src="'data:image/png;base64,' + preview">
              <img v-else width="100px" class="img-circle" height="100px" id="profile_img" alt="foto de perfil"
                   src="../../../public/img/profile.png">

            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label><strong>Limpar foto atual:</strong></label>
              <a id="profile_foto_atual"></a>

              <input id="foto-clear_id" type="checkbox" name="foto-clear" v-model="fotoClear"
                     style="margin-left: 10px;">
              <label for="foto-clear_id" style="margin-left: 5px;">Limpar</label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label><strong>Modificar:</strong></label>
              <div class="input-group">
                <div class="custom-file">
                  <input id="inputGroupFile01" type="file" class="custom-file-input" @change="modificarFoto">
                  <label class="custom-file-label" for="inputGroupFile01">{{ fotoSelecionada }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputMask id="celular" v-model="dado.celular" size="small" style="width: 100%"
                           mask="(99) 9.9999-9999"/>
                <label for="celular"><strong>Celular: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="setor" v-model="dado.setor" size="small" style="width: 100%"/>
                <label for="setor"><strong>Setor: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="cargo" v-model="dado.cargo" size="small" style="width: 100%"/>
                <label for="cargo"><strong>Cargo: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="fechar">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiUrl} from "@/router/apiBackRoutes";
import {apiRequest} from "../../../public/js/utils/funcoes";


export default {
  name: "EditarPerfilUser",
  components: {
    BaseModal,
  },
  emits: ["fechar", "atualizarPerfilUsuario"],
  props: {
    usuarioId: Number,
  },
  data() {
    return {
      dado: {
        foto: null,
        empresa: '',
        celular: '',
        setor: '',
        cargo: '',
      },
      fotoModificada: null,
      fotoSelecionada: "Escolha sua imagem",
      fotoClear: false,
      preview: null,
      erro: null,
      userLogado: localStorage.getItem('admin_userID'),
      isSuperUser: localStorage.getItem('admin_isSuperUser') === 'true',
    }
  },
  methods: {
    fechar() {
      this.$emit("fechar");
    },
    modificarFoto(event) {
      const file = event.target.files[0];
      if (file) {
        this.fotoModificada = file;
        this.preview = URL.createObjectURL(file);
        this.fotoSelecionada = file.name;
        this.fotoClear = false;
      }
    },
    async fetchUsuarioEditPerfil() {
      try {
        const response = await fetch(apiUrl.usuarios.perfilUpdate(this.usuarioId), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: 'include',
        });

        if (!response.ok) {
          this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        }
        const data = await response.json();
        this.dado = data;
        this.preview = data.foto;

      } catch (error) {
        this.erro = error.message;
      }
    },
    async submitEditPerfilForm() {

      try {

        const form = new FormData();
        if (this.fotoModificada && !this.fotoClear) {
          form.append('foto', this.fotoModificada);
        }
        if (this.fotoClear) {
          form.append('foto_clear', true);
        }
        form.append('usuario', this.dado.usuario);
        form.append('setor', this.dado.setor || '');
        form.append('cargo', this.dado.cargo || '');
        form.append('celular', this.dado.celular || '');

        const response = await fetch(apiUrl.usuarios.perfilUpdate(this.usuarioId), {
          method: "PATCH",
          credentials: 'include',
          body: form
        });

        if (!response.ok) {
          const errorData = await response.json();
          this.$toastMessage("warn", "Atenção", "Error ao editar dados do perfil");
          console.log(errorData);
        } else {
          const perfilAtualizado = await response.json();
          this.$emit('atualizarPerfilUsuario', perfilAtualizado);
          this.$toastMessage("success", "Dados alterados com sucesso!");
          this.fechar();
          if (this.dado.foto && this.userLogado === this.usuarioId) {
            localStorage.setItem('admin_userFoto', this.preview)
          }
        }
      } catch (error) {
        this.$toastMessage("warn", "Atenção", "Error ao editar dados!");
        console.log(error)
      }
    },
  },
  mounted() {
    this.fetchUsuarioEditPerfil();
  },
}
</script>
